import React,{useState,useEffect,useCallback}from'react';
import{useNavigate}from'react-router-dom';
import Layout from'../components/layout/Layout';
import {getCurrencySymbol} from '../utils/locale';
import {useTranslation} from 'react-i18next';

const INP=({value,onChange,type='text',placeholder='',disabled=false}:any)=>(
  <input type={type} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled}
    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#015CA6] disabled:bg-gray-50"/>
);
const SEL=({value,onChange,children}:any)=>(
  <select value={value} onChange={onChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none">{children}</select>
);
const FLD=({label,children,required}:any)=>(
  <div><label className="block text-xs font-semibold text-gray-600 mb-1">{label}{required&&<span className="text-red-500 ml-0.5">*</span>}</label>{children}</div>
);
const kes=(v:any)=>v!=null&&v!==''?`${getCurrencySymbol()} ${(+v).toLocaleString('en-KE')}`:'-';

const CATEGORIES=['CONSULTATION','OPD_PROCEDURE','IPD_PROCEDURE','SURGERY','LABORATORY','RADIOLOGY','PHARMACY','WARD_CHARGE','ICU_CHARGE','BED_CHARGE','NURSING','DIETARY','PHYSIOTHERAPY','CARDIOLOGY','NEUROLOGY','OPHTHALMOLOGY','DENTAL','DIALYSIS','ENDOSCOPY','EMERGENCY','AMBULANCE','BLOOD_BANK','CSSD','LAUNDRY','EQUIPMENT','PACKAGE','OTHER'];
const BASE=process.env.REACT_APP_API_URL;
const hdr=()=>({'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('accessToken')||localStorage.getItem('token')||''}`});

const DEF_SVC={
  serviceCode:'',serviceName:'',category:'CONSULTATION',department:'',description:'',unit:'Per Visit',hsnCode:'',
  unitPrice:'',taxPercentage:'16',  // Kenya VAT 16%
  nhifRate:'',governmentRate:'',corporateRate:'',vipRate:'',staffRate:'',insuranceRate:'',
  isActive:true,
  // SHA
  shaInterventionCode:'',shaSubBenefitCode:'',isSHACovered:false,requiresPreAuth:false,shaApprovedRate:'',
};
const DEF_CORP={corporateName:'',corporateCode:'',contactPerson:'',email:'',phone:'',
  address:'',discountPercent:'',creditLimit:'',paymentTermsDays:'30',isActive:true};
const DEF_PKG={packageCode:'',packageName:'',category:'SURGERY',description:'',
  totalAmount:'',validityDays:'30',inclusions:'',exclusions:'',isActive:true};

export default function ChargeMasterPage(){
  const {t}=useTranslation();
  const nav=useNavigate();
  const [tab,setTab]=useState<'services'|'corporate'|'insurance'|'packages'|'ward_rates'|'doctor_fees'>('services');
  const [services,setServices]=useState<any[]>([]);
  const [corporates,setCorporates]=useState<any[]>([]);
  const [insurancePayers,setInsurancePayers]=useState<any[]>([]);
  const [packages,setPackages]=useState<any[]>([]);
  const [apiCats,setApiCats]=useState<string[]>([]);
  const [syncing,setSyncing]=useState(false);
  const [wards,setWards]=useState<any[]>([]);
  const [doctors,setDoctors]=useState<any[]>([]);
  const [search,setSearch]=useState('');
  const [catFilter,setCatFilter]=useState('');
  const [shaFilter,setShaFilter]=useState<'all'|'sha'|'non_sha'>('all');
  const [msg,setMsg]=useState('');
  const [showForm,setShowForm]=useState(false);
  const [editItem,setEditItem]=useState<any>(null);
  const [loading,setLoading]=useState(false);
  const [sf,setSf]=useState<any>({...DEF_SVC});
  const [cf,setCf]=useState<any>({...DEF_CORP});
  const [pf,setPf]=useState<any>({...DEF_PKG});

  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),3500);};

  const load=useCallback(async()=>{
    setLoading(true);
    const[s,p,w,d,ir,cats]=await Promise.all([
      fetch(`${BASE}/billing/services`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/enterprise/packages`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/enterprise/wards`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/users/doctors`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/payers`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/billing/services/categories`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setServices(Array.isArray(s)?s:s?.data||s?.services||[]);
    setPackages(Array.isArray(p)?p:p?.data||[]);
    setWards(Array.isArray(w)?w:w?.data||[]);
    setDoctors(Array.isArray(d)?d:d?.data||d?.data?.doctors||[]);
    setInsurancePayers(Array.isArray(ir)?ir:ir?.data||[]);
    setApiCats((Array.isArray(cats)?cats:[]).filter(Boolean).sort());
    setLoading(false);
  },[]);

  useEffect(()=>{load();},[load]);

  // ── Save service ────────────────────────────────────────────────────────────
  const saveSvc=async()=>{
    if(!sf.serviceCode||!sf.serviceName)return notify('❌ Service code and name required');
    if(!sf.unitPrice)return notify('❌ Unit price required');
    const payload={
      serviceCode:sf.serviceCode.toUpperCase(),
      serviceName:sf.serviceName,
      category:sf.category,
      department:sf.department||null,
      description:sf.description||null,
      unit:sf.unit||'Per Visit',
      hsnCode:sf.hsnCode||null,
      unitPrice:+sf.unitPrice,
      taxPercentage:sf.isSHACovered?0:(+sf.taxPercentage||0),
      isActive:sf.isActive,
      // Additional Kenya rate tiers
      nhifRate:sf.nhifRate?+sf.nhifRate:null,
      governmentRate:sf.governmentRate?+sf.governmentRate:null,
      corporateRate:sf.corporateRate?+sf.corporateRate:null,
      vipRate:sf.vipRate?+sf.vipRate:null,
      staffRate:sf.staffRate?+sf.staffRate:null,
      insuranceRate:sf.insuranceRate?+sf.insuranceRate:null,
      // SHA Mapping
      shaInterventionCode:sf.shaInterventionCode?.toUpperCase()||null,
      shaSubBenefitCode:sf.shaSubBenefitCode?.toUpperCase()||null,
      isSHACovered:sf.isSHACovered||false,
      requiresPreAuth:sf.requiresPreAuth||false,
      shaApprovedRate:sf.shaApprovedRate?+sf.shaApprovedRate:null,
    };
    const url=editItem?`${BASE}/billing/services/${editItem.id}`:`${BASE}/billing/services`;
    const r=await fetch(url,{method:editItem?'PUT':'POST',headers:hdr(),body:JSON.stringify(payload)});
    if(r.ok){notify(editItem?'✅ Service updated':'✅ Service created');setShowForm(false);setEditItem(null);setSf({...DEF_SVC});load();}
    else{const e=await r.json().catch(()=>({}));notify('❌ '+(e?.message||'Failed'));}
  };

  const saveCorp=async()=>{
    if(!cf.corporateName)return notify('❌ Corporate name required');
    const url=editItem?`${BASE}/corporate/${editItem.id}`:`${BASE}/corporate`;
    const r=await fetch(url,{method:editItem?'PUT':'POST',headers:hdr(),body:JSON.stringify({...cf,discountPercent:+cf.discountPercent||0,creditLimit:cf.creditLimit?+cf.creditLimit:null,paymentTermsDays:+cf.paymentTermsDays||30})});
    if(r.ok){notify(editItem?'✅ Updated':'✅ Created');setShowForm(false);setEditItem(null);setCf({...DEF_CORP});load();}
    else notify('❌ Failed');
  };

  const savePkg=async()=>{
    if(!pf.packageName||!pf.totalAmount)return notify('❌ Name and amount required');
    const url=editItem?`${BASE}/enterprise/packages/${editItem.id}`:`${BASE}/enterprise/packages`;
    const r=await fetch(url,{method:editItem?'PUT':'POST',headers:hdr(),body:JSON.stringify({...pf,totalAmount:+pf.totalAmount,validityDays:+pf.validityDays||30})});
    if(r.ok){notify(editItem?'✅ Updated':'✅ Created');setShowForm(false);setEditItem(null);setPf({...DEF_PKG});load();}
    else notify('❌ Failed');
  };

  const del=async(endpoint:string,id:string)=>{
    if(!window.confirm('Delete this item?'))return;
    await fetch(`${BASE}/${endpoint}/${id}`,{method:'DELETE',headers:hdr()});
    notify('✅ Deleted');load();
  };

  const filtSvc=services.filter((s:any)=>{
    if(catFilter&&(s.category||s.service_category)!==catFilter)return false;
    if(shaFilter==='sha'&&!(s.is_sha_covered||s.isSHACovered))return false;
    if(shaFilter==='non_sha'&&(s.is_sha_covered||s.isSHACovered))return false;
    if(search){const q=search.toLowerCase();
      return(s.service_name||s.serviceName||'').toLowerCase().includes(q)
        ||(s.service_code||s.serviceCode||'').toLowerCase().includes(q)
        ||(s.sha_intervention_code||s.shaInterventionCode||'').toLowerCase().includes(q)
        ||(s.department||'').toLowerCase().includes(q);}
    return true;
  });

  const shaCnt=services.filter((s:any)=>s.is_sha_covered||s.isSHACovered).length;
  const preAuthCnt=services.filter((s:any)=>s.requires_pre_auth||s.requires_preauth||s.requiresPreAuth).length;
  const CAT_OPTS=Array.from(new Set(CATEGORIES.concat(apiCats)));

  const syncCatalog=async()=>{
    setSyncing(true);
    const r=await fetch(`${BASE}/billing/services/sync-catalog`,{method:'POST',headers:hdr()});
    const body=await r.json().catch(()=>({}));
    setSyncing(false);
    if(r.ok){notify(`✅ Charge Master synced — ${body.inserted||0} added, ${body.updated||0} updated`);load();}
    else notify('❌ '+(body?.message||'Sync failed'));
  };

  const TABS=[['services','💰 Services'],['corporate','🏢 Corporate'],['insurance','🛡️ Insurance'],['ward_rates','🛏️ Ward Rates'],['packages','📦 Packages'],['doctor_fees','👨‍⚕️ Doctor Fees']];

  return(
    <Layout title="Charge Master & Rate Management" actions={
      <div className="flex gap-2">
        {tab==='services'&&<button onClick={()=>{setEditItem(null);setSf({...DEF_SVC});setShowForm(true);}} className="px-4 py-1.5 rounded-lg text-sm font-semibold text-white bg-[#02357A] hover:bg-[#015CA6]">+ Add Service</button>}
        {tab==='services'&&<button onClick={syncCatalog} disabled={syncing} className="px-4 py-1.5 rounded-lg text-sm font-semibold border border-teal-600 text-teal-700 hover:bg-teal-50">{syncing?'Syncing…':'🛡️ Sync SHA Charge Master'}</button>}
        {tab==='corporate'&&<button onClick={()=>{setEditItem(null);setCf({...DEF_CORP});setShowForm(true);}} className="px-4 py-1.5 rounded-lg text-sm font-semibold text-white bg-[#02357A] hover:bg-[#015CA6]">+ Add Corporate</button>}
        {tab==='packages'&&<button onClick={()=>{setEditItem(null);setPf({...DEF_PKG});setShowForm(true);}} className="px-4 py-1.5 rounded-lg text-sm font-semibold text-white bg-[#02357A] hover:bg-[#015CA6]">+ Add Package</button>}
        <button onClick={()=>nav('/billing')} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Billing</button>
      </div>
    }>
      <div className="p-4">
        {msg&&<div className={`mb-4 p-3 rounded-xl text-sm font-medium border ${msg.startsWith('✅')?'bg-green-50 border-green-200 text-green-700':'bg-red-50 border-red-200 text-red-700'}`}>{msg}</div>}

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-5">
          {[['Total Services',services.length,'#02357A'],['SHA Covered',shaCnt,'#039089'],['Pre-Auth Required',preAuthCnt,'#d97706'],['Corporates',corporates.length,'#7c3aed'],['Packages',packages.length,'#16a34a']].map(([l,v,c])=>(
            <div key={l as string} className="bg-white rounded-xl border p-3" style={{borderLeft:`4px solid ${c}`}}>
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{l}</p>
              <p className="text-2xl font-bold mt-1" style={{color:c as string}}>{v}</p>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl overflow-x-auto">
          {TABS.map(([t,l])=>(
            <button key={t} onClick={()=>setTab(t as any)} className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${tab===t?'bg-white text-[#02357A] shadow font-semibold':'text-gray-600 hover:text-gray-800'}`}>{l}</button>
          ))}
        </div>

        {/* ═══ SERVICES ═══ */}
        {tab==='services'&&(
          <>
            <div className="flex gap-3 mb-4 flex-wrap">
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, code, SHA code, department..." className="flex-1 min-w-48 border rounded-xl px-4 py-2 text-sm focus:outline-none"/>
              <select value={catFilter} onChange={e=>setCatFilter(e.target.value)} className="border rounded-xl px-3 py-2 text-sm bg-white">
                <option value="">All Categories</option>{CAT_OPTS.map(c=><option key={c}>{c}</option>)}
              </select>
              <div className="flex gap-1 bg-gray-100 p-1 rounded-xl">
                {[['all','All'],['sha','🛡️ SHA'],['non_sha','Non-SHA']].map(([v,l])=>(
                  <button key={v} onClick={()=>setShaFilter(v as any)} className={`px-3 py-1 rounded-lg text-xs font-medium ${shaFilter===v?'bg-white shadow text-teal-700 font-semibold':'text-gray-500'}`}>{l}</button>
                ))}
              </div>
            </div>

            {loading?<div className="text-center py-12 text-gray-400">Loading...</div>:filtSvc.length===0?(
              <div className="text-center py-12 bg-white rounded-2xl border">
                <p className="text-4xl mb-3">💰</p>
                <p className="font-bold text-gray-700">No services found</p>
                <button onClick={()=>{setEditItem(null);setSf({...DEF_SVC});setShowForm(true);}} className="mt-4 px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A] hover:bg-[#015CA6]">+ Add First Service</button>
              </div>
            ):(
              <div className="bg-white rounded-xl border overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm min-w-max">
                    <thead>
                      <tr style={{background:'#02357A'}}>
                        {['Code','Service Name','Category','Dept','Unit Price','NHIF Rate','Corp Rate','VAT%','SHA Code','SHA','PreAuth','SHA Rate','Actions'].map(h=>(
                          <th key={h} className="px-3 py-3 text-left text-xs font-bold text-white uppercase whitespace-nowrap">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {filtSvc.map((s:any,idx:number)=>{
                        const code=s.service_code||s.serviceCode||'—';
                        const name=s.service_name||s.serviceName||'—';
                        const cat=s.category||'—';
                        const dept=s.department||'—';
                        const price=s.unit_price??s.unitPrice??'';
                        const nhif=s.nhif_rate??s.nhifRate??'';
                        const corp=s.corporate_rate??s.corporateRate??'';
                        const tax=s.tax_percentage??s.taxPercentage??0;
                        const shaCode=s.sha_intervention_code||s.shaInterventionCode||'';
                        const shaCovered=s.is_sha_covered||s.isSHACovered||false;
                        const preAuth=s.requires_preauth||s.requiresPreAuth||false;
                        const shaRate=s.sha_approved_rate??s.shaApprovedRate??'';
                        return(
                          <tr key={s.id} className={`hover:bg-gray-50/50 ${idx%2===0?'':'bg-gray-50/30'}`}>
                            <td className="px-3 py-2.5 font-mono text-xs font-bold text-[#02357A]">{code}</td>
                            <td className="px-3 py-2.5 font-medium text-gray-800 max-w-40 truncate">{name}</td>
                            <td className="px-3 py-2.5"><span className="px-2 py-0.5 bg-blue-50 text-[#02357A] rounded text-xs font-semibold">{cat}</span></td>
                            <td className="px-3 py-2.5 text-xs text-gray-500">{dept}</td>
                            <td className="px-3 py-2.5 font-bold text-sm text-gray-800">{kes(price)}</td>
                            <td className="px-3 py-2.5 text-xs">{kes(nhif)}</td>
                            <td className="px-3 py-2.5 text-xs">{kes(corp)}</td>
                            <td className="px-3 py-2.5 text-xs text-center">{tax?`${tax}%`:'-'}</td>
                            <td className="px-3 py-2.5 font-mono text-xs text-teal-700 font-semibold">{shaCode||<span className="text-slate-300">—</span>}</td>
                            <td className="px-3 py-2.5 text-center">{shaCovered?<span className="text-xs bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full font-bold">✓</span>:<span className="text-slate-300 text-xs">—</span>}</td>
                            <td className="px-3 py-2.5 text-center">{preAuth?<span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-bold">⚠️</span>:<span className="text-slate-300 text-xs">{t('common.no','No')}</span>}</td>
                            <td className="px-3 py-2.5 text-xs text-teal-700 font-semibold">{shaRate?kes(shaRate):<span className="text-slate-300">—</span>}</td>
                            <td className="px-3 py-2.5">
                              <div className="flex gap-1">
                                <button onClick={()=>{setEditItem(s);setSf({
                                  serviceCode:code,serviceName:name,category:cat,department:dept==='—'?'':dept,
                                  description:s.description||'',unit:s.unit||'Per Visit',hsnCode:s.hsn_code||s.hsnCode||'',
                                  unitPrice:String(price),taxPercentage:String(tax),
                                  nhifRate:String(nhif||''),governmentRate:String(s.government_rate||s.governmentRate||''),
                                  corporateRate:String(corp||''),vipRate:String(s.vip_rate||s.vipRate||''),
                                  staffRate:String(s.staff_rate||s.staffRate||''),insuranceRate:String(s.insurance_rate||s.insuranceRate||''),
                                  isActive:s.is_active!==false,
                                  shaInterventionCode:shaCode,shaSubBenefitCode:s.sha_sub_benefit_code||s.shaSubBenefitCode||'',
                                  isSHACovered:shaCovered,requiresPreAuth:preAuth,shaApprovedRate:String(shaRate||''),
                                });setShowForm(true);}} className="px-2 py-1 rounded text-xs bg-gray-50 hover:bg-gray-100">✏️</button>
                                <button onClick={()=>del('billing/services',s.id)} className="px-2 py-1 rounded text-xs bg-red-50 text-red-500 hover:bg-red-100">🗑️</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="p-3 border-t bg-gray-50 flex items-center justify-between">
                  <p className="text-xs text-gray-400">{filtSvc.length} services · {shaCnt} SHA · {preAuthCnt} pre-auth</p>
                  <p className="text-xs text-teal-600 font-semibold">🛡️ SHA codes auto-apply at CPOE & billing</p>
                </div>
              </div>
            )}
          </>
        )}

        {/* ═══ CORPORATE ═══ */}
        {tab==='corporate'&&(
          corporates.length===0?(
            <div className="text-center py-12 bg-white rounded-2xl border">
              <p className="text-4xl mb-3">🏢</p><p className="font-bold text-gray-700">No corporate accounts</p>
              <button onClick={()=>{setEditItem(null);setCf({...DEF_CORP});setShowForm(true);}} className="mt-4 px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A]">+ Add Corporate</button>
            </div>
          ):(
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {corporates.map((c:any)=>(
                <div key={c.id} className="bg-white rounded-xl border shadow-sm p-4">
                  <p className="font-bold text-gray-900">{c.corporate_name||c.corporateName}</p>
                  <p className="text-xs text-gray-400 font-mono mb-3">{c.corporate_code||c.corporateCode||'—'}</p>
                  <div className="grid grid-cols-2 gap-2 p-2 bg-gray-50 rounded-lg mb-3 text-center">
                    <div><p className="font-bold text-[#039089]">{c.discount_percent||c.discountPercent||0}%</p><p className="text-xs text-gray-400">{t('common.discount','Discount')}</p></div>
                    <div><p className="font-bold text-[#02357A]">{c.payment_terms_days||c.paymentTermsDays||30}d</p><p className="text-xs text-gray-400">Credit Terms</p></div>
                  </div>
                  <div className="flex gap-1">
                    <button onClick={()=>{setEditItem(c);setCf({corporateName:c.corporate_name||c.corporateName||'',corporateCode:c.corporate_code||c.corporateCode||'',contactPerson:c.contact_person||c.contactPerson||'',email:c.email||'',phone:c.phone||'',address:c.address||'',discountPercent:String(c.discount_percent||c.discountPercent||''),creditLimit:String(c.credit_limit||c.creditLimit||''),paymentTermsDays:String(c.payment_terms_days||c.paymentTermsDays||30),isActive:c.is_active!==false});setShowForm(true);}} className="flex-1 py-1.5 rounded-lg text-xs bg-gray-50 hover:bg-gray-100 font-medium">✏️ Edit</button>
                    <button onClick={()=>del('corporate',c.id)} className="px-3 py-1.5 rounded-lg text-xs bg-red-50 text-red-500 hover:bg-red-100">🗑️</button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {/* ═══ INSURANCE ═══ */}
        {tab==='insurance'&&(
          insurancePayers.length===0?(
            <div className="text-center py-12 bg-white rounded-2xl border">
              <p className="text-4xl mb-3">🛡️</p><p className="font-bold text-gray-700">No insurance payers configured</p>
              <button onClick={()=>nav('/payers')} className="mt-4 px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A]">Open Payer Management</button>
            </div>
          ):(
            <div className="bg-white rounded-xl border overflow-hidden">
              <table className="w-full text-sm">
                <thead><tr style={{background:'#02357A'}}>{['Payer Name','Type','Discount %','Credit Days','Status','Actions'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-bold text-white">{h}</th>)}</tr></thead>
                <tbody className="divide-y">
                  {insurancePayers.map((p:any,i:number)=>(
                    <tr key={p.id} className={i%2===0?'':'bg-gray-50/50'}>
                      <td className="px-4 py-3 font-semibold">{p.payer_name||p.payerName||'—'}</td>
                      <td className="px-4 py-3"><span className="px-2 py-0.5 bg-blue-50 text-[#02357A] rounded text-xs font-bold">{p.payer_type||p.payerType||'—'}</span></td>
                      <td className="px-4 py-3 text-xs font-semibold text-[#039089]">{p.discount_percent||p.discountPercent||0}%</td>
                      <td className="px-4 py-3 text-xs">{p.credit_days||p.creditDays||30} days</td>
                      <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-bold ${p.is_active!==false?'bg-green-100 text-green-700':'bg-gray-100 text-gray-500'}`}>{p.is_active!==false?'Active':'Inactive'}</span></td>
                      <td className="px-4 py-3"><button onClick={()=>nav('/payers')} className="px-3 py-1 rounded text-xs bg-blue-50 text-[#02357A] hover:bg-blue-100">Manage</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}

        {/* ═══ WARD RATES ═══ */}
        {tab==='ward_rates'&&(
          wards.length===0?(
            <div className="text-center py-12 bg-white rounded-2xl border">
              <p className="text-4xl mb-3">🛏️</p><p className="font-bold text-gray-700">No wards configured</p>
              <button onClick={()=>nav('/ipd')} className="mt-4 px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A]">Go to IPD → Wards</button>
            </div>
          ):(
            <div className="bg-white rounded-xl border overflow-hidden">
              <table className="w-full text-sm">
                <thead><tr style={{background:'#02357A'}}>{['Ward Code','Ward Name','Type','Beds','Rate/Day ({getCurrencySymbol()})','Actions'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-bold text-white">{h}</th>)}</tr></thead>
                <tbody className="divide-y">
                  {wards.map((w:any,i:number)=>{
                    let localRate=String(w.charge_per_day||w.chargePerDay||'');
                    return(
                      <tr key={w.id} className={i%2===0?'':'bg-gray-50/50'}>
                        <td className="px-4 py-3 font-mono text-xs font-bold text-[#02357A]">{w.ward_code||w.wardCode||'—'}</td>
                        <td className="px-4 py-3 font-semibold">{w.ward_name||w.wardName||'—'}</td>
                        <td className="px-4 py-3"><span className="px-2 py-0.5 bg-blue-50 text-[#02357A] rounded text-xs font-bold">{w.ward_type||w.wardType||'—'}</span></td>
                        <td className="px-4 py-3 text-xs font-bold">{w.total_beds||w.totalBeds||0}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span className="text-gray-400 text-sm">{getCurrencySymbol()}</span>
                            <input type="number" defaultValue={localRate} onChange={e=>{localRate=e.target.value;}} placeholder="e.g. 2500" className="w-28 border border-gray-200 rounded-lg px-2 py-1 text-sm focus:outline-none"/>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <button onClick={async()=>{const r=await fetch(`${BASE}/enterprise/wards/${w.id}`,{method:'PUT',headers:hdr(),body:JSON.stringify({chargePerDay:localRate?+localRate:null})});r.ok?notify('✅ Rate updated'):notify('❌ Failed');}} className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-[#039089] hover:bg-teal-700">Save Rate</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
        )}

        {/* ═══ PACKAGES ═══ */}
        {tab==='packages'&&(
          packages.length===0?(
            <div className="text-center py-12 bg-white rounded-2xl border">
              <p className="text-4xl mb-3">📦</p><p className="font-bold text-gray-700">No packages defined</p>
              <button onClick={()=>{setEditItem(null);setPf({...DEF_PKG});setShowForm(true);}} className="mt-4 px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A]">+ Add Package</button>
            </div>
          ):(
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {packages.map((p:any)=>(
                <div key={p.id} className="bg-white rounded-xl border shadow-sm p-4">
                  <p className="font-bold text-gray-900">{p.package_name||p.packageName}</p>
                  <p className="text-xs text-gray-400 font-mono mb-2">{p.package_code||p.packageCode||'—'}</p>
                  <div className="flex items-center justify-between mb-3 p-2 bg-gray-50 rounded-lg">
                    <div><p className="text-xl font-bold text-[#02357A]">{getCurrencySymbol()} {(+p.total_amount||+p.totalAmount||0).toLocaleString('en-KE')}</p><p className="text-xs text-gray-400">Package Price</p></div>
                    <div className="text-right"><p className="text-sm font-semibold text-gray-600">{p.validity_days||p.validityDays||30}d</p><p className="text-xs text-gray-400">Validity</p></div>
                  </div>
                  <div className="flex gap-1">
                    <button onClick={()=>{setEditItem(p);setPf({packageCode:p.package_code||p.packageCode||'',packageName:p.package_name||p.packageName||'',category:p.category||'SURGERY',description:p.description||'',totalAmount:String(p.total_amount||p.totalAmount||''),validityDays:String(p.validity_days||p.validityDays||30),inclusions:p.inclusions||'',exclusions:p.exclusions||'',isActive:p.is_active!==false});setShowForm(true);}} className="flex-1 py-1.5 rounded-lg text-xs bg-gray-50 hover:bg-gray-100 font-medium">✏️ Edit</button>
                    <button onClick={()=>del('enterprise/packages',p.id)} className="px-3 py-1.5 rounded-lg text-xs bg-red-50 text-red-500 hover:bg-red-100">🗑️</button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {/* ═══ DOCTOR FEES ═══ */}
        {tab==='doctor_fees'&&(
          <div className="bg-white rounded-xl border overflow-hidden">
            {doctors.length===0?<div className="text-center py-12"><p className="text-4xl mb-3">👨‍⚕️</p><p className="font-bold text-gray-700">No doctors found</p></div>:(
              <table className="w-full text-sm">
                <thead><tr style={{background:'#02357A'}}>{['Doctor','Specialization','Consultation ({getCurrencySymbol()})','Follow-up ({getCurrencySymbol()})','Video ({getCurrencySymbol()})','Actions'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-bold text-white">{h}</th>)}</tr></thead>
                <tbody className="divide-y">
                  {doctors.map((d:any,i:number)=>{
                    const dName=`Dr. ${d.first_name||d.firstName||''} ${d.last_name||d.lastName||''}`.trim();
                    let lC=String(d.consultation_fee||d.consultationFee||'');
                    let lF=String(d.follow_up_fee||d.followUpFee||'');
                    let lV=String(d.video_fee||d.videoFee||'');
                    return(
                      <tr key={d.id} className={i%2===0?'':'bg-gray-50/50'}>
                        <td className="px-4 py-3"><p className="font-semibold">{dName}</p><p className="text-xs text-gray-400">{d.employee_id||d.employeeId||'—'}</p></td>
                        <td className="px-4 py-3 text-xs">{d.specialization||d.department||'—'}</td>
                        <td className="px-4 py-3"><input type="number" defaultValue={lC} onChange={e=>{lC=e.target.value;}} placeholder="500" className="w-28 border rounded-lg px-2 py-1 text-sm focus:outline-none"/></td>
                        <td className="px-4 py-3"><input type="number" defaultValue={lF} onChange={e=>{lF=e.target.value;}} placeholder="300" className="w-28 border rounded-lg px-2 py-1 text-sm focus:outline-none"/></td>
                        <td className="px-4 py-3"><input type="number" defaultValue={lV} onChange={e=>{lV=e.target.value;}} placeholder="400" className="w-28 border rounded-lg px-2 py-1 text-sm focus:outline-none"/></td>
                        <td className="px-4 py-3"><button onClick={async()=>{const r=await fetch(`${BASE}/users/${d.id}`,{method:'PUT',headers:hdr(),body:JSON.stringify({consultationFee:lC?+lC:null,followUpFee:lF?+lF:null,videoFee:lV?+lV:null})});r.ok?notify('✅ Updated'):notify('❌ Failed');}} className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-[#039089] hover:bg-teal-700">{t('common.save','Save')}</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* ═══ SERVICE FORM MODAL ═══ */}
        {showForm&&tab==='services'&&(
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={()=>setShowForm(false)}/>
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden max-h-[90vh] flex flex-col">
              <div className="px-6 py-4 flex items-center justify-between flex-shrink-0" style={{background:'linear-gradient(135deg,#02357A,#015CA6)'}}>
                <h3 className="font-bold text-white">{editItem?'Edit Service':'Add New Service / Charge'}</h3>
                <button onClick={()=>setShowForm(false)} className="text-white/70 hover:text-white text-lg font-bold">✕</button>
              </div>
              <div className="p-6 overflow-y-auto space-y-5">

                {/* Basic Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <FLD label="Service Code" required><INP value={sf.serviceCode} onChange={(e:any)=>setSf((x:any)=>({...x,serviceCode:e.target.value.toUpperCase()}))} placeholder="LAB-CBC-001"/></FLD>
                  <FLD label="Service Name" required><INP value={sf.serviceName} onChange={(e:any)=>setSf((x:any)=>({...x,serviceName:e.target.value}))} placeholder="Complete Blood Count"/></FLD>
                  <FLD label="Category" required><SEL value={sf.category} onChange={(e:any)=>setSf((x:any)=>({...x,category:e.target.value}))}>{CAT_OPTS.map(c=><option key={c}>{c}</option>)}</SEL></FLD>
                  <FLD label="Department"><INP value={sf.department} onChange={(e:any)=>setSf((x:any)=>({...x,department:e.target.value}))} placeholder="e.g. Laboratory, Radiology"/></FLD>
                  <FLD label="Unit"><INP value={sf.unit} onChange={(e:any)=>setSf((x:any)=>({...x,unit:e.target.value}))} placeholder="Per Visit, Per Test, Per Day"/></FLD>
                  <FLD label="VAT % (Kenya 16%)"><INP type="number" value={sf.taxPercentage} onChange={(e:any)=>setSf((x:any)=>({...x,taxPercentage:e.target.value}))} placeholder="16"/></FLD>
                </div>

                {/* Pricing */}
                <div className="border-t pt-4">
                  <p className="text-xs font-bold text-gray-500 uppercase mb-3">Pricing ({getCurrencySymbol()})</p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <FLD label="Unit Price (Cash/General)" required>
                      <div className="flex items-center gap-1"><span className="text-gray-400 text-sm">{getCurrencySymbol()}</span><INP type="number" value={sf.unitPrice} onChange={(e:any)=>setSf((x:any)=>({...x,unitPrice:e.target.value}))} placeholder="0"/></div>
                    </FLD>
                    {[['nhifRate','NHIF Rate'],['governmentRate','Government Rate'],['corporateRate','Corporate Rate'],['vipRate','VIP Rate'],['staffRate','Staff Rate'],['insuranceRate','Private Insurance Rate']].map(([k,l])=>(
                      <FLD key={k} label={l}>
                        <div className="flex items-center gap-1"><span className="text-gray-400 text-sm">{getCurrencySymbol()}</span><INP type="number" value={sf[k]} onChange={(e:any)=>setSf((x:any)=>({...x,[k]:e.target.value}))} placeholder="—"/></div>
                      </FLD>
                    ))}
                  </div>
                </div>

                {/* SHA Mapping */}
                <div className="border-t pt-4">
                  <div className="bg-teal-50 border border-teal-200 rounded-xl p-4">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xl">🛡️</span>
                      <div>
                        <p className="text-sm font-bold text-teal-800">SHA / SHIF Mapping</p>
                        <p className="text-xs text-teal-600">Link to DHA benefit codes for automatic claim billing</p>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-3 mb-4">
                      <label className={`flex items-center gap-2 cursor-pointer px-4 py-2 rounded-xl border-2 transition-all ${sf.isSHACovered?'border-teal-400 bg-teal-100':'border-slate-200 bg-white hover:border-teal-300'}`}>
                        <input type="checkbox" checked={sf.isSHACovered} onChange={e=>setSf((x:any)=>({...x,isSHACovered:e.target.checked}))} className="w-4 h-4"/>
                        <span className="text-sm font-semibold text-teal-800">✓ SHA Covered</span>
                      </label>
                      <label className={`flex items-center gap-2 cursor-pointer px-4 py-2 rounded-xl border-2 transition-all ${sf.requiresPreAuth?'border-amber-400 bg-amber-50':'border-slate-200 bg-white hover:border-amber-300'}`}>
                        <input type="checkbox" checked={sf.requiresPreAuth} onChange={e=>setSf((x:any)=>({...x,requiresPreAuth:e.target.checked}))} className="w-4 h-4"/>
                        <span className="text-sm font-semibold text-amber-800">⚠️ Pre-Auth Required</span>
                      </label>
                    </div>
                    {sf.isSHACovered&&(
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <FLD label="SHA Intervention Code"><INP value={sf.shaInterventionCode} onChange={(e:any)=>setSf((x:any)=>({...x,shaInterventionCode:e.target.value.toUpperCase()}))} placeholder="e.g. SHA-06-01-001"/></FLD>
                        <FLD label="SHA Sub-Benefit Code"><INP value={sf.shaSubBenefitCode} onChange={(e:any)=>setSf((x:any)=>({...x,shaSubBenefitCode:e.target.value.toUpperCase()}))} placeholder="e.g. SHA-06-01"/></FLD>
                        <FLD label="SHA Approved Rate ({getCurrencySymbol()})">
                          <div className="flex items-center gap-1"><span className="text-gray-400 text-sm">{getCurrencySymbol()}</span><INP type="number" value={sf.shaApprovedRate} onChange={(e:any)=>setSf((x:any)=>({...x,shaApprovedRate:e.target.value}))} placeholder="SHA tariff"/></div>
                        </FLD>
                      </div>
                    )}
                    {!sf.isSHACovered&&<p className="text-xs text-slate-400">Enable SHA Covered to map this service to DHA benefit codes</p>}
                    {sf.isSHACovered&&!sf.shaInterventionCode&&<p className="text-xs text-amber-600 mt-2">⚠️ Enter SHA Intervention Code (e.g. SHA-06-01-001) to enable auto-billing at CPOE</p>}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <input type="checkbox" checked={sf.isActive} onChange={e=>setSf((x:any)=>({...x,isActive:e.target.checked}))} className="w-4 h-4 rounded"/>
                  <label className="text-sm font-medium">Active Service</label>
                </div>
              </div>
              <div className="px-6 py-4 border-t flex gap-3 flex-shrink-0">
                <button onClick={()=>setShowForm(false)} className="flex-1 py-2.5 border rounded-xl text-gray-600 text-sm">{t('common.cancel','Cancel')}</button>
                <button onClick={saveSvc} className="flex-1 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A] hover:bg-[#015CA6]">{editItem?'Update Service':'Create Service'}</button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ CORPORATE FORM ═══ */}
        {showForm&&tab==='corporate'&&(
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={()=>setShowForm(false)}/>
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
              <div className="px-6 py-4 flex items-center justify-between" style={{background:'linear-gradient(135deg,#02357A,#015CA6)'}}>
                <h3 className="font-bold text-white">{editItem?'Edit Corporate':'Add Corporate Account'}</h3>
                <button onClick={()=>setShowForm(false)} className="text-white/70 hover:text-white text-lg font-bold">✕</button>
              </div>
              <div className="p-6 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <FLD label="Corporate Name" required><INP value={cf.corporateName} onChange={(e:any)=>setCf((x:any)=>({...x,corporateName:e.target.value}))} placeholder="Safaricom, Equity Bank"/></FLD>
                  <FLD label="Corporate Code"><INP value={cf.corporateCode} onChange={(e:any)=>setCf((x:any)=>({...x,corporateCode:e.target.value.toUpperCase()}))} placeholder="SAF-001"/></FLD>
                  <FLD label="Contact Person"><INP value={cf.contactPerson} onChange={(e:any)=>setCf((x:any)=>({...x,contactPerson:e.target.value}))}/></FLD>
                  <FLD label="Phone"><INP value={cf.phone} onChange={(e:any)=>setCf((x:any)=>({...x,phone:e.target.value}))}/></FLD>
                  <FLD label="Email"><INP type="email" value={cf.email} onChange={(e:any)=>setCf((x:any)=>({...x,email:e.target.value}))}/></FLD>
                  <FLD label="Discount %"><INP type="number" value={cf.discountPercent} onChange={(e:any)=>setCf((x:any)=>({...x,discountPercent:e.target.value}))} placeholder="10"/></FLD>
                  <FLD label="Credit Limit ({getCurrencySymbol()})"><INP type="number" value={cf.creditLimit} onChange={(e:any)=>setCf((x:any)=>({...x,creditLimit:e.target.value}))}/></FLD>
                  <FLD label="Payment Terms (days)"><INP type="number" value={cf.paymentTermsDays} onChange={(e:any)=>setCf((x:any)=>({...x,paymentTermsDays:e.target.value}))} placeholder="30"/></FLD>
                </div>
                <div className="flex gap-3">
                  <button onClick={()=>setShowForm(false)} className="flex-1 py-2.5 border rounded-xl text-gray-600 text-sm">{t('common.cancel','Cancel')}</button>
                  <button onClick={saveCorp} className="flex-1 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A] hover:bg-[#015CA6]">{editItem?'Update':'Add Corporate'}</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ═══ PACKAGE FORM ═══ */}
        {showForm&&tab==='packages'&&(
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={()=>setShowForm(false)}/>
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
              <div className="px-6 py-4 flex items-center justify-between" style={{background:'linear-gradient(135deg,#02357A,#015CA6)'}}>
                <h3 className="font-bold text-white">{editItem?'Edit Package':'Add New Package'}</h3>
                <button onClick={()=>setShowForm(false)} className="text-white/70 hover:text-white text-lg font-bold">✕</button>
              </div>
              <div className="p-6 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <FLD label="Package Code"><INP value={pf.packageCode} onChange={(e:any)=>setPf((x:any)=>({...x,packageCode:e.target.value.toUpperCase()}))} placeholder="MAT-PKG-001"/></FLD>
                  <FLD label="Package Name" required><INP value={pf.packageName} onChange={(e:any)=>setPf((x:any)=>({...x,packageName:e.target.value}))} placeholder="Normal Delivery Package"/></FLD>
                  <FLD label="Category"><SEL value={pf.category} onChange={(e:any)=>setPf((x:any)=>({...x,category:e.target.value}))}>{CATEGORIES.map(c=><option key={c}>{c}</option>)}</SEL></FLD>
                  <FLD label="Total Amount ({getCurrencySymbol()})" required><INP type="number" value={pf.totalAmount} onChange={(e:any)=>setPf((x:any)=>({...x,totalAmount:e.target.value}))} placeholder="25000"/></FLD>
                  <FLD label="Validity (days)"><INP type="number" value={pf.validityDays} onChange={(e:any)=>setPf((x:any)=>({...x,validityDays:e.target.value}))} placeholder="30"/></FLD>
                  <div className="col-span-2"><FLD label="Description"><INP value={pf.description} onChange={(e:any)=>setPf((x:any)=>({...x,description:e.target.value}))}/></FLD></div>
                  <div className="col-span-2"><FLD label="Inclusions"><textarea value={pf.inclusions} onChange={e=>setPf((x:any)=>({...x,inclusions:e.target.value}))} rows={2} placeholder="Room, OT, Surgeon fee..." className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none"/></FLD></div>
                  <div className="col-span-2"><FLD label="Exclusions"><textarea value={pf.exclusions} onChange={e=>setPf((x:any)=>({...x,exclusions:e.target.value}))} rows={2} placeholder="Blood transfusion, ICU..." className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none"/></FLD></div>
                </div>
                <div className="flex gap-3">
                  <button onClick={()=>setShowForm(false)} className="flex-1 py-2.5 border rounded-xl text-gray-600 text-sm">{t('common.cancel','Cancel')}</button>
                  <button onClick={savePkg} className="flex-1 py-2.5 rounded-xl text-white font-semibold text-sm bg-[#02357A] hover:bg-[#015CA6]">{editItem?'Update':'Create Package'}</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
